export default function samlReducer(state = {
  samlResponse: null,
  fetching: false,
  fetched: false,
}, action) {
  switch (action.type) {
      case 'SAML_RESPONSE_PENDING': {
        return {
          ...state,
          fetching: true,
          fetched: false,
          samlResponse: null
      }
      }
      case 'SAML_RESPONSE_FULFILLED': {
          return {
              ...state,
              fetching: false,
              fetched: true,
              samlResponse: action.payLoad.samlResponse,
          }
      }
      case 'SAML_RESPONSE_REJECTED':
          return {
              ...state,
              fetching: false,
              fetched: false,
              samlResponse: null
          }
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/samlReducer.js